module.exports = __webpack_public_path__ + "static/media/background.6e3e6965.png";